import GanttChart from './GanttChart';

export default GanttChart;
